import { defineStore } from "pinia";
import { useAuthStore } from "./auth.store";
import FiltersService from "@/services/FiltersService";
import { USER_ACTIVITY_EVENT_TYPES } from "@/constants/userActivityEventTypes";
import { i18n } from "@/main";

// Definicja store'a Pinia do obsługi filtrów na liście aktywności użytkowników
export const useUserActivityFiltersStore = defineStore({
  id: "userActivityFilter",
  state: () => ({
    // Domyślne filtry ostatnie 24h
    filters: {
      dateTimeStart: new Date(
        new Date().setDate(new Date().getDate() - 1)
      ).toISOString(),
      dateTimeEnd: new Date().toISOString(),
    },
    users: [],              // Lista użytkowników do wyboru w filtrach
    eventTypes: {},
    authStore: useAuthStore(), // Referencja do store’a autoryzacji (np. do obsługi błędów)
    requireFields: [],      // Pola wymagane (brakujące) przy walidacji
    error: null,            // Bieżący komunikat błędu
  }),
  getters: {},
  actions: {
    // Pobierz listę użytkowników do filtrowania (jeśli nie została jeszcze pobrana)
    getUsers() {
      if (this.users.length === 0) {
        FiltersService.getUserActivityFilterValues()
          .then((data) => {
            const usersResponse = Array.isArray(data?.users) ? data.users : [];
            const tmpArray = [];
            if (usersResponse.length > 0) {
              for (const item in usersResponse) {
                const us = usersResponse[item];
                tmpArray.push({ id: us.id, name: us.username });
              }
            }
            this.users = tmpArray; // Aktualizacja stanu users

            const enabledEventIds = Object.keys(data?.eventTypes ?? {})
              .map((value) => Number(value))
              .filter((value) => !Number.isNaN(value));

            this.eventTypes = enabledEventIds.reduce((acc, eventId) => {
              const label = USER_ACTIVITY_EVENT_TYPES[eventId];
              if (label) {
                acc[eventId] = label;
              }
              return acc;
            }, {});

            const selected = Number(this.filters.eventTypes);
            if (this.filters.eventTypes && !enabledEventIds.includes(selected)) {
              this.filters.eventTypes = "";
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
    },
    // Dodaj lub aktualizuj filtr
    addItem(name, value) {
      // console.log(`Adding filter: ${name} with value: ${value}`);
      this.filters[name] = value;
    },
    // Sprawdź czy wymagane dane zostały podane w filtrach
    checkRequireData() {
      this.requireFields = [];
      this.error = false;

      if (!this.filters.dateTimeEnd) {
        this.requireFields.push("dateTimeEnd");
      }
      if (!this.filters.dateTimeStart) {
        this.requireFields.push("dateTimeStart");
      }

      if (this.requireFields.length) {
        this.error = true;
        this.setErrors(i18n.global.t('required-parameter-missing'));
      }
    },
    // Ustaw błąd (i komunikat błędu w store autoryzacji)
    setErrors(error) {
      console.log(`Setting error: ${error}`);
      this.authStore.errorMessage = error;
    },
  },
});

// Obsługa Hot Module Replacement (do developmentu)
// if (typeof import.meta !== 'undefined' && import.meta.hot) {
//   import.meta.hot.accept(
//     acceptHMRUpdate(useUserActivityFiltersStore, import.meta.hot)
//   );
// }
